import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useAcademicYear } from '../contexts/AcademicYearContext';

const BulkOuvertureModal = ({ show, onClose, classes }) => {
  const { selectedYear } = useAcademicYear();
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleBulkOpen = async () => {
    setLoading(true);
    const res = [];
    for (const c of classes) {
      try {
        const response = await api.post('/ouvertures-classes', {
          classe_id: c.id,
          annee_scolaire_id: selectedYear.id,
        });
        if (response.data.success) {
          res.push({
            status: 'success',
            message: `Classe de ${c.classe} ouverte avec succès pour l'année scolaire ${selectedYear.annee_scolaire}`,
          });
        } else {
          res.push({
            status: 'warning',
            message: `Classe de ${c.classe} déjà ouverte pour l'année scolaire ${selectedYear.annee_scolaire}`,
          });
        }
      } catch (e) {
        res.push({
          status: 'warning',
          message: `Classe de ${c.classe} déjà ouverte pour l'année scolaire ${selectedYear.annee_scolaire}`,
        });
      }
    }
    setResults(res);
    setLoading(false);
  };

  useEffect(() => {
    if (show) {
      setResults([]);
      setLoading(false);
    }
  }, [show]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-2xl">
        <h2 className="text-xl font-semibold mb-4">Ouvrir toutes les classes pour {selectedYear?.annee_scolaire}</h2>
        {results.length === 0 && (
          <button
            className="px-4 py-2 bg-primary-600 text-white rounded-lg mb-4"
            onClick={handleBulkOpen}
            disabled={loading}
          >
            {loading ? 'Ouverture en cours...' : 'Lancer l\'ouverture'}
          </button>
        )}
        <ul className="mb-4">
          {results.map((r, idx) => (
            <li
              key={idx}
              className={`mb-2 px-2 py-1 rounded ${
                r.status === 'success'
                  ? 'bg-green-100 text-green-800'
                  : 'bg-yellow-100 text-yellow-800'
              }`}
            >
              {r.message}
            </li>
          ))}
        </ul>
        {results.length > 0 && (
          <div className="font-bold text-center mb-4">
            Toutes les classes ({results.length}) ont été ouvertes pour l'année scolaire {selectedYear?.annee_scolaire}
          </div>
        )}
        <div className="flex justify-end">
          <button
            className="px-4 py-2 bg-gray-200 rounded-lg"
            onClick={onClose}
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkOuvertureModal;
